import styled from '@emotion/styled';
import parse from 'html-react-parser';
import { useFormContext } from 'react-hook-form';

import { screen } from '@/components/common/breakpointsV2';
import { StyledActionButton } from '@/components/common/Button';
import { captionSmall } from '@/components/common/elements';
import { HubspotConsent } from '@/components/forms/HubspotFormNew/HubspotConsent';
import { HubspotFormField } from '@/components/forms/HubspotFormNew/HubspotFormField';
import { getLegalConsentFromMetadata } from '@/components/forms/HubspotFormNew/hubspotUtils';

export const HubspotFormFullPage = ({ formData }: any) => {
  const {
    control,
    formState: { errors, isSubmitting },
  } = useFormContext();
  const variant = 'fresh';
  const { submitText, formFieldGroups, guid, metaData } = formData;

  const legalConsent = getLegalConsentFromMetadata(metaData);

  return (
    <>
      <FormFieldsStack>
        {formFieldGroups?.map((fieldGroup, index) => (
          <fieldset
            className={`form-columns-${fieldGroup.fields.length}`}
            // eslint-disable-next-line react/no-array-index-key
            key={`fieldGroup-${index}`}
          >
            {fieldGroup.fields.map((field) => (
              <HubspotFormField
                formId={guid}
                key={field.name}
                field={field}
                control={control}
                error={errors[field.name]}
                variant={variant}
              />
            ))}
            {fieldGroup.richText?.type === 'TEXT' && (
              <div className="hs-richtext">
                {parse(fieldGroup.richText.content)}
              </div>
            )}
          </fieldset>
        ))}
      </FormFieldsStack>

      {legalConsent && <HubspotConsent consentData={legalConsent} />}

      <FooterContainer className="hs-submit submit-btn footer-container">
        <StyledActionButton
          backgroundOfParent="deep-space"
          className="hs-button"
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : submitText}
        </StyledActionButton>
      </FooterContainer>
    </>
  );
};

const FormFieldsStack = styled.div`
  .hs-richtext p {
    ${captionSmall}
    margin-top: var(--spacing-50);
  }
  display: flex;
  flex-direction: column;
  gap: var(--spacing-200);
`;

const FooterContainer = styled.div`
  padding: var(--spacing-200) 0 var(--spacing-300) 0;
  > button {
    width: 100%;
    justify-content: center;
  }

  ${screen.md} {
    position: sticky;
    bottom: 0;
    backdrop-filter: blur(8px);
    background: rgba(255, 255, 255, 0.8);
    border-radius: 0 0 var(--border-radius-small) var(--border-radius-small);
    display: flex;
    justify-content: flex-end;
    padding: var(--spacing-150) 0 var(--spacing-300) 0;

    > button {
      width: unset;
    }
  }
`;
